import { useGetShipmentApiV1ShipmentsShipmentIdGet } from '#/shared/api/generated/shipment/theCargoShipment'

export function useCustomerEmail(
  shipmentId: string | undefined,
): string | undefined {
  const query = useGetShipmentApiV1ShipmentsShipmentIdGet(shipmentId ?? '', {
    query: { enabled: Boolean(shipmentId) },
  })
  return query.data?.data.customer?.email ?? undefined
}
